import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { SchoolService } from "../../../shared/services/school.service";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { AttendanceViewService } from "./attendanceview.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import * as moment from "moment";

@Component({
	selector: "caass-dynamicReport-AttendanceView",
	templateUrl: "./AttendanceView.component.html",
	styles: [
		`
			table {
				width: 100%;
			}

			thead,
			tbody,
			tr,
			td,
			th {
				display: block;
			}

			tr:after {
				content: " ";
				display: block;
				visibility: hidden;
				clear: both;
			}

			thead th {
				height: 40px;

				/*text-align: left;*/
			}

			tbody {
				height: 700px;
				overflow-y: auto;
			}

			thead {
				/* fallback */
			}

			tbody td,
			thead th {
				float: left;
			}
		`,
	],
})
export class AttendanceViewComponent {
	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	schoolList: any = [];
	attendanceViewList: any = [];
	AttendanceViewList: any = [];
	studentsDetail: any = [];
	sortedByList: any = [];
	displaySchoolList: any = [];
	SelectedSchoolID = 0;
	reportDate = new Date();
	SelectedDate = new Date();
	showStudentList = false;
	attendanceID: any = 0;
	showInstructorTable = false;
	loadingInstructorTable = false;
	showFilters = false;
	periodList: any = [];
	instructorList: any = [];
	courseList: any = [];
	SelectedSortBy: any = 0;
	InstructorSelected: any = 0;

	SelectedStatusID: any = 0;
	SelectedPeriod: any = 0;
	SelectedInstructor: any = 0;
	SelectedCourse: any = 0;
	attendancePercentage: any = 0;

	AStatusList = [
		{ StatusID: 1, StatusDesc: "All" },
		{ StatusID: 2, StatusDesc: "Taken" },
		{ StatusID: 3, StatusDesc: "Not Taken" },
	];
	SortByList = [
		{ SortByID: 1, SortByDesc: "Period" },
		{ SortByID: 2, SortByDesc: "Instructor" },
		{ SortByID: 3, SortByDesc: "Section" },
	];
	selectedAttendanceID: any = 0;
	constructor(private selectService: SchoolselectorService, private schoolService: SchoolService, private attendanceviewService: AttendanceViewService) {}

	ngOnInit() {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	subscription: any;

	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "Select the school",
					});
				} else if (this.schoolList.length > 0) {
					this.SelectedSchoolID = this.schoolList[0].SchoolID;
				}
			},
			(error) => {}
		);
	}
	onSchoolChange(newSchoolID) {
		this.SelectedSchoolID = newSchoolID;
		this.showInstructorTable = false;
		this.showFilters = false;
	}
	onDateChange(newClassDate) {
		this.reportDate = newClassDate;
		this.showInstructorTable = false;
		this.showFilters = false;
	}
	onSortByChange(newSortByID) {
		var sortByID = newSortByID;

		if (sortByID == 1) {
			this.sortByPeriod();
		} else if (sortByID == 2) {
			this.sortByInstructor();
		} else if (sortByID == 3) {
			this.sortBySection();
		}
	}
	onAStatusChange(newStatusID) {
		var statusID = newStatusID;
		if (statusID == 1) {
			this.filterAll();
		} else if (statusID == 2) {
			this.filterTaken();
		} else if (statusID == 3) {
			this.filterNotTaken();
		}
	}

	onPeriodChange(newPeriod) {
		this.SelectedPeriod = newPeriod;
		this.sortedByList = [];
		var listByPeriod = this.attendanceViewList.filter(function (a) {
			return a.Period == newPeriod;
		});
		this.sortedByList = listByPeriod;
	}
	onInstructorChange(newInstructor) {
		this.SelectedInstructor = newInstructor;
		this.sortedByList = [];
		var listByPeriod = this.attendanceViewList.filter(function (a) {
			return a.InstructorName == newInstructor;
		});
		this.sortedByList = listByPeriod;
	}

	onCourseChange(newCourse) {
		this.SelectedCourse = newCourse;
		this.sortedByList = [];
		var listByPeriod = this.attendanceViewList.filter(function (a) {
			return a.CourseDesc == newCourse;
		});
		this.sortedByList = listByPeriod;
	}

	onClickShowReport() {
		this.loadingInstructorTable = true;
		this.showFilters = false;
		this.SchoolAdminAttendanceGetlist();
	}
	private SchoolAdminAttendanceGetlist() {
		var result = this.attendanceviewService.SchoolAdminAttendanceGetlist(this.SelectedSchoolID, moment(this.reportDate).format("MM/DD/YYYY"));

		result.subscribe(
			(response: any) => {
				this.sortedByList = [];
				this.loadingInstructorTable = false;
				this.attendanceViewList = response;

				if (this.attendanceViewList != null && this.attendanceViewList.length > 0) {
					this.attendancePercentage = this.attendanceViewList[0].AttendancePercentageTaken;
					this.showFilters = true;
					this.showInstructorTable = true;
					this.GetPeriodList();
					this.GetInstructorList();
					this.GetCourseList();
					this.sortedByList = this.attendanceViewList;
				} else {
					this.showFilters = false;
					this.showInstructorTable = false;
					this.sortedByList = [];
				}
			},
			(error) => {}
		);
	}
	private GetPeriodList() {
		var pList = this.attendanceViewList.map((item) => item.Period).filter((value, index, self) => self.indexOf(value) === index);

		this.periodList = pList.sort();
		if (this.periodList.length > 1) {
			this.periodList.unshift("Select Period");
		}
	}

	private GetInstructorList() {
		var IList = this.attendanceViewList.map((item) => item.InstructorName).filter((value, index, self) => self.indexOf(value) === index);
		this.instructorList = IList.sort();
		if (this.instructorList.length > 1) {
			this.instructorList.unshift("Select Instructor");
		}
	}

	private GetCourseList() {
		var CList = this.attendanceViewList.map((item) => item.CourseDesc).filter((value, index, self) => self.indexOf(value) === index);
		this.courseList = CList.sort();
		if (this.courseList.length > 1) {
			this.courseList.unshift("Select Course");
		}
	}

	private sortByPeriod() {
		// this.sortedByList = [];
		this.sortedByList = this.attendanceViewList.sort(function (a, b) {
			var nameA = a.Period.toLowerCase(),
				nameB = b.Period.toLowerCase();
			if (nameA < nameB)
				//sort string ascending
				return -1;
			if (nameA > nameB) return 1;
			return 0;
		});
	}
	private sortByInstructor() {
		// this.sortedByList = [];
		this.sortedByList = this.attendanceViewList.sort(function (a, b) {
			var nameA = a.InstructorName.toLowerCase(),
				nameB = b.InstructorName.toLowerCase();
			if (nameA < nameB)
				//sort string ascending
				return -1;
			if (nameA > nameB) return 1;
			return 0;
		});
	}
	private sortBySection() {
		// this.sortedByList = [];
		this.sortedByList = this.attendanceViewList.sort(function (a, b) {
			var nameA = a.Section.toLowerCase(),
				nameB = b.Section.toLowerCase();
			if (nameA < nameB)
				//sort string ascending
				return -1;
			if (nameA > nameB) return 1;
			return 0;
		});
	}
	private filterAll() {
		this.sortedByList = this.attendanceViewList;
	}
	private filterTaken() {
		this.sortedByList = [];
		var Ataken = this.attendanceViewList.filter(function (a) {
			return a.AStatus == "Taken";
		});
		this.sortedByList = Ataken;
	}
	private filterNotTaken() {
		this.sortedByList = [];
		var ANottaken = this.attendanceViewList.filter(function (a) {
			return a.AStatus == "Not Taken";
		});
		this.sortedByList = ANottaken;
	}
	pullStudents(classAttendanceID) {
		this.showStudentList = false;
		if (classAttendanceID == "") {
			this.showStudentList = false;
		} else {
			this.selectedAttendanceID = classAttendanceID;
			var check = this.attendanceViewList.filter((a) => {
				return a.ClassAttendanceID == classAttendanceID;
			});
			this.attendanceID = check[0].ClassAttendanceID;
			this.InstructorSelected = check[0].InstructorName;
			var result = this.attendanceviewService.SchoolAdminAttendanceDetailGetList(this.attendanceID);
			result.subscribe(
				(response: any) => {
					this.studentsDetail = [];

					this.studentsDetail = response;
				},
				(error) => {}
			);
			this.showStudentList = true;

			$("#myBtn").click(function () {
				$("#myModal").modal();
			});
		}
	}
}
